const triggers = document.querySelectorAll('[data-cookie-settings]');

triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
        document.body.dataset.cookiebanner = 'on';
        if (window.klaro && typeof window.klaro.show === 'function') {
            window.klaro.show();
        }
    });
});
